import React from 'react';
import classnames from 'classnames';

/**
 * Skeleton placeholder for study-browser thumbnails while preview image is missing or loading.
 */
export function ThumbnailImagePlaceholder({
  className,
}: {
  className?: string;
}): React.ReactNode {
  return (
    <div
      aria-hidden
      className={classnames(
        'absolute inset-0 z-[1] overflow-hidden rounded',
        'bg-muted/90',
        className
      )}
    >
      <div className="animate-pulse absolute inset-0 bg-gradient-to-br from-muted via-muted-foreground/15 to-muted" />
      <div className="absolute inset-0 flex flex-col justify-end">
        <div className="h-2 w-[72%] rounded-sm bg-white/12" />
        <div className="h-2 w-[48%] rounded-sm bg-white/10" />
      </div>
    </div>
  );
}
